import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=15288676&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15288676')) {
      api.createRecord('15288676', component.options)
    } else {
      api.reload('15288676', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=15288676&", function () {
      api.rerender('15288676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QECLCaU8AzT6/JS/comp/openstreetmap.vue"
export default component.exports